/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Equal_Big_Shrimp_TasteInputs */

const fr_equal_big_shrimp_taste = /** @type {(inputs: Equal_Big_Shrimp_TasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu te souviens de ton mot de passe ?`)
};

/**

* @param {Equal_Big_Shrimp_TasteInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const equal_big_shrimp_taste = /** @type {((inputs?: Equal_Big_Shrimp_TasteInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equal_Big_Shrimp_TasteInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_equal_big_shrimp_taste(inputs)
});